import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { BsFileEarmarkPlus } from "react-icons/bs";
import { Link } from "react-router-dom";
import styles from "./ViewWeeklyFiles.module.css";

import { connect } from "react-redux";
import {
  getWeeklyFiles,
  deleteWeeklyFile,
  deleteAllWeeklyFilesByBatch,
} from "../../actions/WeeklyFile";
import { years } from "../../constants/MonthsAndYears";
import { weekArray } from "../../constants/WeekArray";
import FileList from "./FileList";
import { useModals } from "@mantine/modals";
import { Text } from "@mantine/core";
import { toast } from "react-toastify";

const ViewWeeklyFiles = ({
  grades,
  getWeeklyFiles,
  deleteWeeklyFile,
  deleteAllWeeklyFilesByBatch,
  hideDelete = false,
}) => {
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [week, setWeek] = useState("1");
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState(null);
  const [deletingAll, setDeletingAll] = useState(false);
  const [deletingAllBatch, setDeletingAllBatch] = useState(false);
  const modals = useModals();

  const selectHandeler = async () => {
    setLoading(true);
    try {
      const list = await getWeeklyFiles(year, grade, shift, batch, week);
      if (list !== false) {
        setFiles(list);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteAllHandler = () => {
    if (!files || files.length === 0) {
      toast.warning("No files to delete");
      return;
    }

    modals.openConfirmModal({
      title: "Delete all files",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete all {files.length} file(s)? This
          action is destructive and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete All", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmDeleteAll(),
    });
  };

  const confirmDeleteAll = async () => {
    if (!files || files.length === 0) return;

    setDeletingAll(true);
    let successCount = 0;
    let failCount = 0;

    try {
      for (const file of files) {
        const result = await deleteWeeklyFile(file.id);
        if (result !== false) {
          successCount++;
        } else {
          failCount++;
        }
      }

      if (successCount > 0) {
        toast.success(`Successfully deleted ${successCount} file(s)`);
      }
      if (failCount > 0) {
        toast.error(`Failed to delete ${failCount} file(s)`);
      }

      // Refresh the file list
      const list = await getWeeklyFiles(year, grade, shift, batch, week);
      if (list !== false) {
        setFiles(list);
      } else {
        setFiles([]);
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while deleting files");
    } finally {
      setDeletingAll(false);
    }
  };

  const deleteAllBatchHandler = () => {
    if (!batch || !year) {
      toast.warning("Please select batch and year");
      return;
    }

    modals.openConfirmModal({
      title: "Delete all weekly files for this batch",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete ALL weekly files for this batch and
          year ({year})? This action will delete all files across all weeks for
          this batch. This action is destructive and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete All", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmDeleteAllBatch(),
    });
  };

  const confirmDeleteAllBatch = async () => {
    if (!batch || !year) return;

    setDeletingAllBatch(true);
    try {
      const result = await deleteAllWeeklyFilesByBatch(batch, year);
      if (result !== false) {
        // Refresh the file list if files are currently displayed
        if (files) {
          const list = await getWeeklyFiles(year, grade, shift, batch, week);
          if (list !== false) {
            setFiles(list);
          } else {
            setFiles([]);
          }
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred while deleting files");
    } finally {
      setDeletingAllBatch(false);
    }
  };

  return (
    <div>
      {/* <div className="d-flex justify-content-end align-items-center pb-3 ">
        <div className="text-right">
          <Link to="/admin/weekly-files/add" className={styles.add}>
            <BsFileEarmarkPlus />
          </Link>
        </div>
      </div> */}

      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}

            {grade !== "" && shift !== "" && batch !== "" ? (
              <Col
                md={3}
                className="d-flex jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  className="btn_primary"
                >
                  {loading ? "Loading..." : "Select"}
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="week" className="d-block">
                  Week
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setWeek(e.target.value);
                }}
                id="week"
                value={week}
                name="week"
              >
                {weekArray.map((item) => (
                  <option key={item} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                value={year}
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {batch && year && !hideDelete && (
        <Card bg="white" text="dark" className={`crd shadow mt-3`}>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="my-auto">Batch Operations for {year}</h5>
              <Button
                variant="danger"
                onClick={deleteAllBatchHandler}
                disabled={deletingAllBatch}
                className="btn-danger"
              >
                {deletingAllBatch
                  ? "Deleting..."
                  : "Delete All Weekly Files for This Batch"}
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {files && files.length > 0 && !hideDelete && (
        <Card bg="white" text="dark" className={`crd shadow mt-3`}>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="my-auto">
                Found {files.length} file(s) for Week {week} of {year}
              </h5>
              <Button
                variant="danger"
                onClick={deleteAllHandler}
                disabled={deletingAll}
                className="btn-danger"
              >
                {deletingAll ? "Deleting..." : "Delete All"}
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {files ? (
        <FileList files={files} setFiles={setFiles} hideDelete={hideDelete} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default connect(null, {
  getWeeklyFiles,
  deleteWeeklyFile,
  deleteAllWeeklyFilesByBatch,
})(ViewWeeklyFiles);
